module.exports = __webpack_public_path__ + "img/nerdof_icon.6b30bf93.png";